import { z } from "zod";
export const ForgeAvatarBuilder = z.object({
    headType: z.string(),
    hairType: z.string(),
    accessory1Type: z.string(),
    accessory2Type: z.string(),
});
export const ForgeAgent = z.object({
    avatar: z.union([z.string(), ForgeAvatarBuilder]),
    avatarUrl: z.string().optional(),
    behavior: z.enum(["Coder", "Writer", "Designer"]),
    id: z.string(),
    name: z.string(),
    personality: z.enum(["Neutral", "Assertive", "Crazy"]),
    projectId: z.string(),
});
